<template>
  <div v-if="isLoading" class="loading-overlay">
    <div class="loading-content">
      <img src="../../public/assets/loading-swift.gif" alt="Loading..." class="loading-gif" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isLoading: {
      type: Boolean,
      required: true,
    },
  },
};
</script>

<style>
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  pointer-events: none; 
}

.loading-content {
  pointer-events: auto; /* Allow interaction with loading content if needed */
}

.loading-gif {
  width: 100px;
  height: 100px;
}
</style>